import React, { PureComponent } from 'react'
import Loader from 'react-loading'
import cx from 'classnames'
import Button from '../Button'
import './index.css'

class Select extends PureComponent {
  key = 'dc6zaTOxFJmzC'
  limit = 25
  pending = null
  state = {
    show: false,
    isLoading: false,
    offset: 25,
    search: '',
    gifs: [],
  }

  componentDidMount() {
    this.images.addEventListener('scroll', this.handleImagesScroll)
    document.addEventListener('click', this.handleDocumentClick)
  }

  componentWillUnmount() {
    this.images.removeEventListener('scroll', this.handleImagesScroll)
    document.removeEventListener('click', this.handleDocumentClick)
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      (prevState.search !== this.state.search)
      || (prevState.show !== this.state.show && this.state.show)
    ) {
      this.load()
    }
  }

  load() {
    this.setState(
      { isLoading: true },
      () => this.state.search === ''
        ? this.loadTrendings()
        : this.loadSearch(),
    )
  }

  loadTrendings() {
    fetch(`https://api.giphy.com/v1/gifs/trending?api_key=${ this.key }&limit=${ this.limit }`)
      .then((response) => response.json())
      .then((response) => this.setState({
        isLoading: false,
        offset: this.limit,
        gifs: response.data,
      }, () => this.images.scrollTop = 0))
  }

  loadSearch() {
    const q = encodeURIComponent(this.state.search)
    clearTimeout(this.pending)

    this.pending = setTimeout(() => {
      fetch(`https://api.giphy.com/v1/gifs/search?api_key=${ this.key }&q=${ q }&limit=${ this.limit }`)
        .then((response) => response.json())
        .then((response) => this.setState({
          isLoading: false,
          offset: this.limit,
          gifs: response.data,
        }, () => this.images.scrollTop = 0))
    }, 1000)
  }

  loadSearchNext() {
    const q = encodeURIComponent(this.state.search)

    fetch(`https://api.giphy.com/v1/gifs/search?api_key=${ this.key }&q=${ q }&limit=${ this.limit }&offset=${ this.state.offset }`)
      .then((response) => response.json())
      .then((response) => this.setState((prevState) => ({
        isLoading: false,
        offset: prevState.offset + this.limit,
        gifs: [
          ...prevState.gifs,
          ...response.data,
        ],
      })))
  }

  handleImagesScroll = () => {
    const { scrollHeight, offsetHeight, scrollTop } = this.images
    const trigger = scrollHeight - (15 / 100 * scrollHeight)
    const scroll = offsetHeight + scrollTop

    if (
      !this.state.isLoading
      && this.state.search !== ''
      && scroll >= trigger
    ) {
      this.setState(
        { isLoading: true },
        () => this.loadSearchNext(),
      )
    }
  }

  handleDocumentClick = (e) => {
    if (!this.select.contains(e.target)) {
      this.setState({ show: false })
    }
  }

  handleClick = (e) => {
    this.setState((prevState) => ({
      show: !prevState.show,
    }))
  }

  handleChange = (e) => this.setState({ search: e.target.value.trim() })

  makeHandleImageClick = (image) => () => {
    if (this.props.onChange) {
      this.props.onChange(image)
    }
  }

  renderGifs(gifs) {
    return gifs.map((gif, index) => (
      <div
        key={ index }
        className={ 'select-image' }
        onClick={ this.makeHandleImageClick(gif.images.original.url) }>
        <img
          src={ gif.images.original.url }
          alt={ gif.slug } />
      </div>
    ))
  }

  render() {
    const { children } = this.props

    return (
      <div
        className={ 'select' }
        ref={ (select) => this.select = select }>
        <Button
          types={ ['button--full'] }
          onClick={ this.handleClick }>
          { children }
        </Button>

        <div className={ cx('select-dropdown', {
          'is-shown': this.state.show,
        }) }>
          { this.state.isLoading && (
            <div className={ 'select-loader' }>
              <Loader
                type="spin"
                color="#000"
                height="1.25rem"
                width="1.25rem" />
            </div>
          ) }

          <input
            type="text"
            placeholder={ 'chercher un GIF...' }
            onChange={ this.handleChange }
            className={ 'select-search' }/>

          <div
            className={ 'select-images' }
            ref={ (images) => this.images = images }>
            { this.renderGifs(this.state.gifs) }
          </div>
        </div>
      </div>
    )
  }
}

export default Select



// WEBPACK FOOTER //
// ./src/components/Select/index.js